import { Controller } from "@hotwired/stimulus"

const TAB_NAMES = ["chart", "tradingview", "data"]

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    const hash = window.location.hash.replace("#", "")
    const initial = TAB_NAMES.includes(hash) ? hash : TAB_NAMES[0]
    // Defer so sibling panel controllers (price-chart, candle-table, …) finish
    // connecting and are listening for `tab:shown` before we dispatch it.
    requestAnimationFrame(() => this.show(initial))
  }

  select(event) {
    this.show(event.currentTarget.dataset.tabName)
  }

  show(name) {
    this.tabTargets.forEach((tab) => {
      tab.classList.toggle("tab-active", tab.dataset.tabName === name)
      tab.setAttribute("aria-selected", tab.dataset.tabName === name)
    })

    this.panelTargets.forEach((panel) => {
      const visible = panel.dataset.tabName === name
      panel.hidden = !visible
      if (visible) panel.dispatchEvent(new CustomEvent("tab:shown"))
    })

    if (window.location.hash !== `#${name}`) {
      history.replaceState(null, "", `#${name}`)
    }
  }
}
